import React from 'react';
import {
  SurveyCreator,
  SurveyCreatorComponent,
  editorLocalization,
} from 'survey-creator-react';
import 'survey-core/defaultV2.css';
import 'survey-creator-core/survey-creator-core.css';
import './surveyJS.css';

const translations = editorLocalization.getLocale('');
export type LocalizationText = {
  ed?: {
    addNewQuestion?: string;
    panelPlaceHolder?: string;
    surveyPlaceHolder?: string;
    newQuestionName?: string;
  };
  survey?: {};
  pe?: { startWithNewLine?: string };
};

type SparkSurveyCreatorProps = {
  creator: SurveyCreator;
  localizationText: LocalizationText;
};
function SparkSurveyCreator({
  creator,
  localizationText,
}: SparkSurveyCreatorProps) {
  React.useEffect(() => {
    Object.entries(localizationText).forEach(
      ([parentKey, childLocalization]) => {
        Object.entries(childLocalization).forEach(
          ([childKey, value]) => (translations[parentKey][childKey] = value)
        );
      }
    );
  }, [localizationText]);

  if (!creator) {
    return null;
  }

  return <SurveyCreatorComponent creator={creator} />;
}

export default SparkSurveyCreator;
